<!--
  工单详情处理结果
-->
<template>
  <div>
    <div class="content-title" style="margin-top: 30px">处理结果</div>
    <div class="flex-c-s">
      <div class="flex-col-center">
        <img :src="result.avatar" class="user-header" />
        <span class="user-name">{{ result.userName }}</span>
      </div>
      <div class="create-time">{{ result.time }}</div>
    </div>
    <div class="result-content white-pre">
      {{ result.content }}
    </div>
    <div class="flex">
      <div v-for="(item, index) in result.files" :key="index">
        <img
          :src="item.fileUrl"
          class="result-image"
          v-if="item.fileType == '0'"
          @click="viewImage(item)"
        />
        <!-- 视频 -->
        <img
          src="@/assets/images/video_logo.png"
          class="result-image"
          v-else-if="item.fileType == '1'"
          @click="viewImage(item)"
        />
        <!-- 文档 -->
        <img
          src="@/assets/images/txt_logo.png"
          class="result-image"
          v-else
          @click="viewImage(item)"
        />
      </div>
    </div>
    <div class="order-line" style="margin: 23px 0 27px 0"></div>

    <!-- 图片查看器 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="viewerUrl"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: {
    ElImageViewer
  },
  props: {
    result: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showViewer: false, // 显示查看器
      viewerUrl: [] // 查看器图片数组
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    // 查看图片
    viewImage(item) {
      const url = item.fileUrl
      if (item.fileType == '0') {
        this.viewerUrl = [url]
        this.showViewer = true
      } else {
        window.open(url)
      }
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>
<style lang="scss" scoped>
.result-content {
  margin-top: 10px;
  margin-bottom: 8px;
  padding: 15px 20px;
  background: #f8faff;
  border-radius: 6px;
  font-size: 14px;
  color: rgba(41, 48, 82, 0.7);
  line-height: 26px;
}

.result-image {
  width: 57px;
  height: 57px;
  margin-right: 16px;
  border-radius: 6px;
  cursor: pointer;
}
</style>
